<script>
const pageOptions = {
  showNavbar: true,
}

export default pageOptions;
</script>
